import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing.module";
import { NotFoundComponent } from "./not_found.component";
import { RestApiCall } from "./core/services/rest-api.service";
import { LocalStorageService } from "./core/services/local-storage.service";

import { HttpModule, Http } from "@angular/http";
import { AuthService } from "./core/authentication/authentication.servicie";
import { Ng2Webstorage } from "ngx-webstorage";
import { AuthGuard } from "./core/authentication/auth.guard";
import { TranslateStaticLoader } from "ng2-translate";
import { LoginService } from "./services/login.service";
import { InvalidUserService } from "./services/invalid-user.service";
import { SessionExpireComponent } from "./session-expire.component";
import { WebStompService } from "./core/services/webstomp.service";
import { StompRService } from "@stomp/ng2-stompjs";
import { CookieService } from 'ngx-cookie-service';
//import { GOOGLE_LOGIN_CONFIG } from './login/shared/g-login.config';
//import { googleConfig } from "../environments/environment";
import { googleConfig } from "../environments/environment";
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { PaginationService } from "./services/pagination.service"
import {GOOGLE_LOGIN_CONFIG, GoogleLoginService} from "@chalo/chalo-angular-login-libraries";
import {ChaloGoogleHybridLoginModule} from "@chalo/chalo-angular-login-libraries";
import { ResponseHandlerInterceptorInterceptor } from "./interceptor/response-handler-interceptor.interceptor";
import { RemoveNullParamsInterceptor, TokenInterceptor} from "./interceptor/token-pass.interceptor";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatCommonModule } from "@angular/material/core";
import { SuccessDialogComponent } from "./core/components/success-dialog/success-dialog.component";
import { TimepickerModule } from "ngx-bootstrap/timepicker";


export function createTranslateLoader(http: Http) {
	return new TranslateStaticLoader(http, './assets/i18n', '.json');
}
export function googleLoginConfigFactory() {
	if (window.location.href.includes('crut') || window.location.href.includes('tsrtc') || window.location.href.includes('tgsrtc')) {
		googleConfig.authCodeUrl = googleConfig.authCodeUrl.replace(/(redirect_uri=)[^&]+/,`redirect_uri=${window.location.origin}`);
	}
	return googleConfig;
}

@NgModule({
	declarations: [
		AppComponent,
		NotFoundComponent,
		SessionExpireComponent,
		SuccessDialogComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpModule,
		Ng2Webstorage,
		BrowserAnimationsModule,
		HttpClientModule,
		ChaloGoogleHybridLoginModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatCommonModule,
		TimepickerModule
		
	],
	providers: [
		RestApiCall,
		AuthService,
		AuthGuard,
		LoginService,
		InvalidUserService,
		WebStompService,
		StompRService,
		CookieService,
		LocalStorageService,
		PaginationService,
		GoogleLoginService,
		{ provide: GOOGLE_LOGIN_CONFIG, useFactory: googleLoginConfigFactory },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true,
		  },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ResponseHandlerInterceptorInterceptor,
			multi: true,
		  },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RemoveNullParamsInterceptor,
			multi: true
		}

	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
